(function () {
    'use strict';
    const {recordPurchaseStage} = require('./modules/purchase-funnel.js');
    const PROMPTS = [
        ['[data-am-pdf-offer]', 'birthchart_pdf', 'open'],
        ['[data-am-ai-offer]', 'birthchart_ai_chat', 'open'],
        ['[data-am-aspects-offer]', 'birthchart_aspects', 'open'],
        ['[data-am-premium-reading-dialog]', 'birthchart_houses', 'open'],
        ['#premiumModal', 'compatibility', 'open'],
        ['#subscriptionModal', 'horoscope', 'class'],
    ];

    function initializePurchasePrompts(documentObject, windowObject) {
        if (!windowObject.MutationObserver || !windowObject.fetch) return [];
        function record(source) {
            if (source !== 'tracking') {
                recordPurchaseStage(windowObject, source, 'offer_viewed');
                return;
            }
            try {
                Promise.resolve(windowObject.fetch('/api/telemetry/purchase-prompt', {
                    method: 'POST',
                    credentials: 'same-origin',
                    referrerPolicy: 'no-referrer',
                    keepalive: true,
                    headers: {'Content-Type': 'application/json'},
                    body: JSON.stringify({source}),
                })).catch(() => {});
            } catch (_) { /* Telemetry never interrupts the action. */ }
        }
        const observers = [];
        for (const [selector, source, attribute] of PROMPTS) {
            const dialog = documentObject.querySelector(selector);
            if (!dialog || dialog.dataset.purchasePromptTracked) continue;
            dialog.dataset.purchasePromptTracked = 'true';
            for (const link of dialog.querySelectorAll?.('a[href^="/assinar"], #subscribeButton') ?? []) {
                link.addEventListener('click', () => recordPurchaseStage(windowObject, source, 'cta_clicked'));
            }
            const visible = () => attribute === 'open'
                ? dialog.hasAttribute('open')
                : !dialog.classList.contains('hidden');
            let wasVisible = visible();
            if (wasVisible) record(source);
            const observer = new windowObject.MutationObserver(() => {
                const isVisible = visible();
                if (isVisible && !wasVisible) record(source);
                wasVisible = isVisible;
            });
            observer.observe(dialog, {attributes: true, attributeFilter: [attribute]});
            observers.push(observer);
        }
        if (observers.length) record('tracking');
        return observers;
    }
    if (typeof document !== 'undefined' && typeof window !== 'undefined') {
        const init = () => initializePurchasePrompts(document, window);
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
        else init();
    }
    if (typeof module !== 'undefined' && module.exports) module.exports = {initializePurchasePrompts};
})();
